import{useRef as r,useEffect as c}from"react";function u(e){let t=r(e);return c(()=>{t.current=e},[e]),t}export{u as useLatestValue};
